import axios from "axios";
import store from "@/V2/store/index"
import { getSessionToken } from "@shopify/app-bridge-utils";

/**
 * Fire-and-forget helper to cache a carrier label PDF in S3.
 * Safe to call from any carrier flow.
 */
export function cacheLabelPdfInS3(labelUrl: string): void {
  if (!labelUrl) return;

  void (async () => {
    const app = store.getters["Shopify/app"];
    if (!app) return;

    const token = await getSessionToken(app);

    await axios.post(
      `${process.env.VUE_APP_V2_SHOPIFY_API}/labels/cache`,
      { url: labelUrl },
      {
        headers: {
          Authorization: token,
        },
        timeout: 30_000,
      }
    );
  })().catch((err) => {
    // Non-critical: swallow errors
    // eslint-disable-next-line no-console
    console.warn("Label PDF cache failed:", err?.message ?? err);
  });
}

/**
 * Get a presigned download URL for a cached label PDF.
 */
export async function getCachedLabelDownloadUrl(labelUrl: string): Promise<string> {
  const app = store.getters["Shopify/app"];
  if (!app) throw new Error("Shopify App Bridge not initialised");

  const token = await getSessionToken(app);

  const res = await axios.post(
    `${process.env.VUE_APP_V2_SHOPIFY_API}/labels/download-url`,
    { url: labelUrl },
    {
      headers: { Authorization: token },
      timeout: 15_000,
    }
  );
  
  const payload = (res.data && typeof res.data.body === "string") ? JSON.parse(res.data.body) : res.data;
  
  return payload
}
